<template>
    <v-container fluid fill-height>
        <Curso :mostrar.sync="abrirCurso" :curso="curso" @aumentaAulasCompletas="aumentaAulasCompletas($event)" @diminuiAulasCompletas="diminuiAulasCompletas($event)" />
        <v-row>
            <v-col cols="12">
                <v-card :loading="loading" tile :height="this.$store.getters.alturaContent -70" style="overflow-y: auto">
                    <v-card-title>
                        <v-toolbar dense flat></v-toolbar>
                        <!-- <v-card v-for="curso in cursos" :key="curso.id" class="mx-3 col-md-4">
                            <v-card-title class="color: primary white--text"><h3>{{curso.nome}}</h3></v-card-title>
                                <v-card-text>

                                </v-card-text>
                            </v-card> -->
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" class="col-sm-6 col-lg-4 col-xl-3 mx-auto" v-for="curso in cursos" :key="curso.id">
                                    <v-card min-height="265">
                                        <v-img class="white--text" 
                                        height="100%" 
                                        min-height="210" 
                                        :src="curso.imagem"
                                        gradient="to top right, rgba(0,0,0,0.5), rgba(0,0,0,1)">
                                            <v-container>
                                                <v-row class="white--text">
                                                    <v-col cols="12">
                                                        <span class="headline"><h3>{{curso.nome}}</h3></span>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <h3>{{curso.descricao}}</h3>
                                                    </v-col>
                                                    <v-col cols="12" class="text-right pr-4">
                                                        <v-avatar class="mx-1" color="primary">
                                                            <img contain v-if="curso.imagem_instrutor != null" :src="curso.imagem_instrutor" />
                                                            <span class="white--text" v-else><h2>{{curso.instrutor.substring(0,1)}}</h2></span>
                                                        </v-avatar>
                                                        {{curso.instrutor}}
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-img>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn v-if="curso.matriculado == '0'" color="primary" @click="matricular(curso.id)">Matricular</v-btn>
                                            <v-btn v-else color="primary" @click="acessarConteudo(curso.id)">Acessar Curso</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import {mapState} from 'vuex'
import Curso from '@/components/estudos/Cursos/Curso'


export default {
    data(){
        return{
            cursos: {},
            curso: {},
            loading: false,
            abrirCurso: false,
            abrirAulaVideo: false,
            urlVideo: null
        }
    },
    computed:{
        ...mapState(['user']),
    },
    components:{Curso},

    methods:{
        chamaAulaVideo(url){
            
            this.urlVideo = url
            this.abrirAulaVideo = true
        },

        aumentaAulasCompletas(id){
            this.curso.aulas_completas = parseInt(this.curso.aulas_completas)
            this.curso.aulas_completas++
        },
        diminuiAulasCompletas(id){
            this.curso.aulas_completas = parseInt(this.curso.aulas_completas)
            this.curso.aulas_completas--
        },
        matricular(id){
            const url = `${baseApiUrl}/estudos/Cursos/matricular.php`    
            let params = {
                idCurso: id,
                idIniciado: this.user.iniciado
            }
            axios.post(url, params).then(res => { 
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.cursos.forEach(v => {
                        if(v.id == id){
                            v.matriculado = '1'
                        }
                    })

                }else{
                    showError(res.data.mensagem)
                }
            })
        },

        async acessarConteudo(id){
            const url = `${baseApiUrl}/estudos/Cursos/readCurso.php?curso=${id}&iniciado=${this.user.iniciado}`
            
            await axios.get(url).then(res => {
                if(res.data.codigo == '01'){
                    
                    this.curso = res.data.curso
                    
                        this.curso.modulos.forEach(m => {
                            m.aulas.forEach(a => {
                                if(a.concluida == '1'){
                                    a.concluida = true
                                }else{
                                    a.concluida = false
                                }
                            })
                        })

                }else{
                    showError(res.data.mensagem)
                }
            })

            this.abrirCurso = true
            
        },

        
    },

    created(){
        
        const url = `${baseApiUrl}/estudos/Cursos/read.php?idIniciado=${this.user.iniciado}&grau=${this.user.outros.grauAtual}`

        axios.get(url).then(res => { 
            if(res.data.codigo == '01'){
                this.cursos = res.data.dados

            }else{
                showError(res.data.mensagem)
            }
        })
    }
}
</script>

<style scoped>
.card-conteudo{
    display: flex;
    flex-direction: column;
}

.grow1{
    flex-grow: 1;
}

.grow2{
    flex-grow: 100;
}
</style>